import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-team_icon0",
  "use": "icon-team_icon0-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" id=\"icon-team_icon0\"><defs><style>#icon-team_icon0 .a{fill:#999;}</style></defs><path class=\"a\" d=\"M8,0l8,12H0Z\" transform=\"translate(12) rotate(90)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol